import React from 'react';
import { render } from 'react-dom';
import App from './App';

const AppDiv = document.createElement('div');
AppDiv.id = 'AppRoot';
document.body.prepend(AppDiv);

render(<App />, AppDiv);
